<template>
  <VehicleBasePriceTabComponent />
  <div v-if="vehicle && vehicle.motors && vehicle.motors[0]" class="group">
    <div class="group__title">{{ getTranslation(185) }}</div>
    <div class="equipments">
      <template v-for="group in vehicle.equipments_groups" :key="group">
        <template v-if="Object.keys(group.equipments['option']).length">
          <div
            v-for="equipment in group.equipments['option']"
            :key="equipment"
            class="equipment"
          >
            {{ equipment.label }} -
            <span class="fw-bold">{{ formatPrice(equipment.price) }} €</span>
          </div>
        </template>
      </template>
    </div>
    <div class="group__title mt-4 mb-2">
      {{ getTranslation(178, { LIBELLE: vehicle.vehicle_label }) }}
    </div>
    <div class="colors">
      <div v-for="color in vehicle.colors" :key="color.id" class="color">
        <div
          :style="'background: #' + color.hex + ';'"
          class="color__preview"
        ></div>
        {{ color.label }}<br />
        <span class="fw-bold">{{
          parseFloat(color.price) ? formatPrice(color.price) + " €" : ""
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { priceManager } from "@/services/price-manager";
import { useMainStore } from "@/store";
import { getTranslation } from "@/services/translation-manager";
import VehicleBasePriceTabComponent from "@/components/VehicleTabs/VehicleBasePriceTabComponent.vue";

export default {
  name: "VehicleOptionPriceTabComponent",
  components: { VehicleBasePriceTabComponent },
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
    }),
  },
  methods: {
    getTranslation,
    formatPrice(price) {
      return priceManager.format(price);
    },
  },
};
</script>

<style lang="scss" scoped>
.group {
  &__title {
    font-weight: 700;
    color: $blue;
    text-transform: uppercase;
    border-bottom: 6px solid $blue;
    padding: 5px 15px;
    font-size: 20px;
  }
}

.equipment {
  padding: 8px 15px;

  &:nth-child(even) {
    background: $white;
  }
}

.colors {
  display: flex;
  width: 100%;
}

.color {
  flex: 1;
  text-align: center;

  &__preview {
    height: 45px;
    margin-bottom: 8px;
  }
}
</style>
